import React, { useContext, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import { Pathname } from 'Routes';
import { AppContext } from 'Context';
import logo from 'Assets/Login Logo.png';
import InivteGrp from '../../../../Assets/InivteGrp.png';
import AppStore from '../../../../Assets/app-store.png';
import Apple from '../../landing-external/assets/img/appstore2.svg';
import Roku from '../../landing-external/assets/img/roku.svg';
import FireTv from '../../landing-external/assets/img/fire-tv.svg';
import Googletv from '../../landing-external/assets/img/google-cast.svg';
import GooglePlay from '../../landing-external/assets/img/playstore.svg';
import UploadStatus from './UploadStatus';
import styles from './index.module.css';

export const DeviceList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const uploadPercentages = useSelector((state) => state.upload);
  console.log('uploadPercentages', uploadPercentages);

  // Detect active uploads
  const activeUploads = Object.entries(uploadPercentages).filter(
    ([_, progress]) => progress !== null && progress !== undefined && progress !== 'Please wait'
  );
  const hasActiveUploads = activeUploads.length > 0;

  const { setAppSnackbar, setNeedToShowETA } = useContext(AppContext);
  const getQueryParam = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  };
  useEffect(() => {
    // callForUpdate();
    setNeedToShowETA(false);
  }, []);
  const suffix = getQueryParam('email');

  // Device click handlers
  const platforms = [
    {
      name: 'Roku',
      url: 'https://channelstore.roku.com/details/e6a1063fcdc0af86bea4707c2b889700:a838d0bb3d0551f9cb7d15cfc993f595/projector',
      image: Roku,
    },
    {
      name: 'Google TV',
      url: 'https://play.google.com/store/apps/details?id=com.projectorllc.projectorapptv',
      image: Googletv,
    },
    {
      name: 'Fire TV',
      url: 'https://www.amazon.com/Projector-LLC/dp/B09TG4ZDJ2/ref=sr_1_1?crid=1NQQX43KDWAX8&dib=eyJ2IjoiMSJ9.XgwdOPTL3iVFzBVnU4OntRPSKtSRiLX4zqhS_M34_6T8z3oblbBdbpunkuQEs84kpQwWW98fSAmNKdS08CjZKTS4kjzPXg_q8xA7KSyy6w_BPVDXtzSHb4UA1if6uRM1B8D0a6GqSdwegUR4l_X1Gg5yLyMVs4Qy5HhhFY26CenvorlZPdH5Fe4-QKN-n1IhfinNfzuETIkEzNjeTL6FzZY9FvQOqZe72WXjm8pQ9Fj8QUwBfcJ9Bsx9J-NVvEdYFZPUZYctBKgXxobiB6RWw87GhVwwvanx0IsIDK3bCIU.g_p6LDfgCwCXPmLcBUHif33V-0ok_KmtIeRNu6VkUyg&dib_tag=se&keywords=projector+app&qid=1758222291&s=mobile-apps&sprefix=projector+app%2Cmobile-apps%2C149&sr=1-1',
      image: FireTv,
    },
    {
      name: 'Android',
      url: 'https://play.google.com/store/apps/details?id=com.projectorllc.projectorapp',
      image: GooglePlay,
    },
    {
      name: 'Appstore',
      url: 'https://apps.apple.com/in/app/projector-stream/id1585850104',
      image: AppStore,
    },
    {
      name: 'Apple TV',
      url: 'https://apps.apple.com/in/app/projector-stream/id1585850104',
      image: Apple,
    },
  ];

  const frontEnd = [
    {
      title: 'Watch On All Your Devices',
      subtitle:
        'Create a Projector and have the ultimate viewing experience for your own \nmemories like never before! \nClick here to start uploading.',
      image: InivteGrp,
      buttonText: 'CLICK HERE TO DOWNLOAD',
      navigation: Pathname.plans,
    },
  ];
  // "Watch on my projector" handler. New-signup flow goes straight to /profile
  // in the SAME tab (no new tab, no welcome page). Gift / everyone else keep the
  // original behaviour (open /profile in a new tab + navigate this tab onward).
  const handleWatchOnProjector = () => {
    if (location.state?.isNewSignupFlow) {
      navigate(Pathname.profile.basePath);
      return;
    }
    const isGift = !!(location.state?.isGiftFlow || getQueryParam('gift') === 'true');
    window.open(isGift ? '/profile?fromGift=true' : '/profile', '_blank');
    navigate(
      isGift ? `${Pathname.yourVideos}?fromGift=true` : Pathname.authentication.toTrail,
      { state: { isGiftFlow: isGift } },
    );
  };

  const values = Object.values(uploadPercentages);

  // "Please wait" means finished, everything else is current
  const current = values.filter((v) => v !== 'Please wait').length;
  const total = values.length;
  return (
    <div className={styles.authPage}>
      <div className={styles.bgOverlay}>
        <div className={styles.bgAccent1} />
        <div className={styles.bgAccent2} />
        <div className={styles.bgCircle} />
      </div>
      {/* Back button for gift flow */}
      {(location.state?.isGiftFlow || new URLSearchParams(location.search).get('fromGift') === 'true' || new URLSearchParams(location.search).get('gift') === 'true') && (
        <div
          aria-hidden="true"
          onClick={() => navigate(-1)}
          className={styles.backLink}
        >
          BACK
        </div>
      )}
      <div>
        <Link to={Pathname.home}>
          <div className={styles.logoDiv}>
            <img className={styles.logoImage} src={logo} alt="projector logo" />
          </div>
          {Object.keys(uploadPercentages).length > 0 && (
            <UploadStatus
              current={Object.values(uploadPercentages).filter((v) => v !== 'Please wait').length}
              total={Object.values(uploadPercentages).length}
            />
          )}

        </Link>
      </div>
      <div>
        {frontEnd?.map((obj, index) => (
          <div key={index} className={styles.each}>
            <h1 className={styles.headx} style={{ fontSize: '36px' }}>
              {obj?.title}
            </h1>
            <div className={styles.flexico}>
              <div>
                <p className={styles.xubheadx}>
                  Get Projector on your TV, Phone and Tablet
                </p>
                <p className={styles.subheadx}>
                  What device do you want to download projector on ?
                </p>
                <div className={styles.deviceGrid}>
                  {platforms.map((platform) => (
                    <div
                      key={platform.name}
                      className={styles.deviceItem}
                      onClick={platform.disable ? undefined : () => window.open(platform.url, '_blank')}
                      role="button"
                      tabIndex={platform.disable ? -1 : 0}
                      onKeyDown={platform.disable ? undefined : (e) => e.key === 'Enter' && window.open(platform.url, '_blank')}
                      style={platform.disable ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
                    >
                      <img className={styles.deviceIcon} src={platform.image} alt={platform.name} />
                      <span className={styles.deviceLabel}>{platform.name}</span>
                    </div>
                  ))}

                </div>
              </div>
            </div>
            {/* Uploading Notification */}
            {hasActiveUploads && (
              <div className={styles.uploadingNotification}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span className={styles.uploadingText}>
                    Uploading your files
                  </span>
                  <div className={styles.uploadingDots}>
                    <span className={styles.uploadingDot1}>.</span>
                    <span className={styles.uploadingDot2}>.</span>
                    <span className={styles.uploadingDot3}>.</span>
                  </div>
                </div>
              </div>
            )}
            <div
              role="button"
              tabIndex={0}
              style={{ justifyContent: 'center' }}
              onClick={handleWatchOnProjector}
              onKeyDown={(e) => { if (e.key === 'Enter') handleWatchOnProjector(); }}
              className={styles.subheadxSkip}
            >
              <span className={styles.hideOnMobile}>Watch on your Computer</span>
              <span className={styles.showOnMobileOnly}>View Your Projector</span>
            </div>
            {!location.state?.isGiftFlow && getQueryParam('gift') !== 'true' && (
              <div
                role="button"
                tabIndex={0}
                style={{ justifyContent: 'center' }}
                onClick={() => navigate(`${Pathname.authentication.invite}${suffix ? `?email=${suffix}` : ''}`)}
                onKeyDown={(e) => e.key === 'Enter' && navigate(`${Pathname.authentication.invite}${suffix ? `?email=${suffix}` : ''}`)}
                className={styles.subheadxSkip}
              >
                Next
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
